import { CharStatus } from "../../lib/statuses";
import classnames from "classnames";

type Props = {
  value?: string;
  status?: CharStatus;
};

export const Cell = ({ value, status }: Props) => {
  const classes = classnames("cell", {
    "cell-empty": !value && !status,
    "cell-filled": value && !status,
    "cell-correct": status === "correct",
    "cell-present": status === "present",
    "cell-absent": status === "absent",
  });

  return <div className={classes}>{value}</div>;
};
